const state = {
  features: {},
};

const getters = {
  getFeatures(state) {
    return state.features;
  },
  getFeature(state) {
    return key => state.features[key];
  },
};

const actions = {
  setFeatures(context, { features }) {
    context.commit('setFeatures', { features });
  },
};

const mutations = {
  setFeatures(state, { features }) {
    state.features = features;
  },
};

const module = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default module;
